import React from 'react'
import TopNav from './components/TopNav.jsx'
import './styles/App.css'
import Nav from './components/Nav.jsx'
import ScrollToTop from './components/ScrollToTop.jsx'
import { Routes, Route } from 'react-router-dom'
import Home from './pages/Home.jsx'
import Projects from './pages/Projects.jsx'
import Services from './pages/Services.jsx'
import Contact from './pages/Contact.jsx'
// import News from './pages/News.jsx'
import Quote from './pages/Quote.jsx'
import Procurement from './pages/Procurement.jsx'
import Corrosion from './pages/Corrosion.jsx'
import Contracting from './pages/Contracting.jsx'
import Construction from './pages/Construction.jsx'
import Engineering from './pages/Engineering.jsx'




function App() {
  return (
    <div>
      <TopNav/>
      <Nav/>
      <ScrollToTop/>
      <Routes>
       <Route path='/' element={<Home/>}/>
   
       <Route path='/Contact' element={<Contact/>}/>
       {/* <Route path='/News' element={<News/>}/> */}
       <Route path='/Services' element={<Services/>}/>
       <Route path='/Projects' element={<Projects/>}/>     
        
       <Route path='/Quote' element={<Quote/>}/>     
       <Route path='/Construction' element={<Construction/>}/>     
       <Route path='/Procurement' element={<Procurement/>}/>     
       <Route path='/Engineering' element={<Engineering/>}/>     
       <Route path='/Contracting' element={<Contracting/>}/>     
       <Route path='/Corrosion' element={<Corrosion/>}/>     
      </Routes>

    </div>
  )
}

export default App

